import LogService from "../../CommonSdk/LogService";

import * as DocumentationActionTypes from "./DocumentationActionTypes";

const LOG_TAG = "ACTIONS:DOCUMENTATION";

export const setDocumentationFilter = (value) => (dispatch) => {
    LogService.trace(LOG_TAG, "setDocumentationFilter");

    dispatch({
        type: DocumentationActionTypes.SET_FILTER,
        value: value
    });
};

export const clearDocumentationFilter = () => dispatch => {
    LogService.trace(LOG_TAG, "clearDocumentationFilter");
    dispatch({
        type: DocumentationActionTypes.CLEAR_FILTER
    });
};

